import DOMPurify from 'dompurify';
window.DOMPurify = DOMPurify;
